import { RefBool } from '@tblabs/truffle';


export class AppSettings
{
    public Sounds = new RefBool(true).Storable("sounds-enabled");
    public CameraConnectionSounds = new RefBool(true).Storable("camera-connection-sounds");
    public NewPictureInLivePreviewMode = new RefBool(false).Storable("new-picture-in-live-preview-mode");
    public NewPictureInSnapshotViewMode = new RefBool(false).Storable("new-picture-in-snapshot-view-mode");
    public SensorsSounds = new RefBool(false).Storable("sensors-sounds-enabled");
}
